const { makeSlug } = require("../../utils/slug")

const normalize = value => (value || "").normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").toLowerCase()
const escape = value => value.replace(/&/g, "&amp;").replace(/</g, "&lt;")
  .replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;")

// Keep snapshot search aligned with the records shipped in this build.
module.exports = function localClient(nodes) {
  const records = nodes.map(({ id, data }) => ({
    objectID: id, name: data.Name, path: makeSlug(data.Name),
    text: normalize([data.Name, data.Tagline, data.About, data.Address].join(" ")),
    _highlightResult: { name: { value: escape(data.Name), matchLevel: "none", matchedWords: [] } },
  }))
  return {
    search(requests) {
      return Promise.resolve({ results: requests.map(({ indexName, params = {} }) => {
        const query = (params.query || "").trim()
        const terms = normalize(query).split(/\s+/).filter(Boolean)
        const matches = terms.length ? records.filter(record =>
          terms.every(term => record.text.includes(term))
        ).sort((a, b) => Number(normalize(b.name).includes(normalize(query))) -
          Number(normalize(a.name).includes(normalize(query))) || a.name.localeCompare(b.name)) : []
        const hitsPerPage = Math.max(1, Number(params.hitsPerPage) || 8)
        const page = Math.max(0, Number(params.page) || 0)
        return {
          hits: matches.slice(page * hitsPerPage, (page + 1) * hitsPerPage),
          nbHits: matches.length, nbPages: Math.ceil(matches.length / hitsPerPage),
          hitsPerPage, page, query, index: indexName, processingTimeMS: 0,
        }
      }) })
    },
  }
}
